import { toggleDisabledAttribute } from '@engine/lib/utility/toggle_disabled_attribute';

function updateFields(supports_managed_recurring) {
  if (supports_managed_recurring) {
    $('#managed_recurring_params').removeClass('hidden');
    toggleDisabledAttribute($('#managed_recurring_params .form-control'), false);
    $('#managed_recurring_params .for_chosen').trigger('chosen:updated');
  } else {
    $('#managed_recurring_params').addClass('hidden');
    toggleDisabledAttribute($('#managed_recurring_params .form-control'), true);
    $('#managed_recurring_params .for_chosen').trigger('chosen:updated');
  }
}

var ManagedRecurring = {
  updateFields: updateFields
};
export default ManagedRecurring;